import api, { UPLOAD_REQUEST_TIMEOUT_MS } from "./api";
import { CardApplicationValues, ExtractedApplicationFields } from "@/types/extraction";

interface ParsedApplication {
  extracted_fields: ExtractedApplicationFields;
  /** Null when the server couldn't map the fields onto the card's. */
  application: CardApplicationValues | null;
}

async function parse(file: File): Promise<ParsedApplication> {
  const formData = new FormData();
  formData.append("file", file);
  const response = await api.post<ParsedApplication>("/ai-services/parse-application/", formData, {
    timeout: UPLOAD_REQUEST_TIMEOUT_MS,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export const extractionService = {
  /**
   * Upload an MCA application PDF and extract structured business fields.
   * Returns extracted fields that can be used to pre-fill the borrower form.
   */
  parseApplication: async (file: File): Promise<ExtractedApplicationFields> =>
    (await parse(file)).extracted_fields,

  /**
   * The same parse, as the assistant's New application card fills from it: the values mapped
   * onto the form's fields (never the SSN) and the server's signature of them. Rejects when the
   * server has none: the card couldn't read it.
   */
  parseApplicationForCard: async (file: File): Promise<CardApplicationValues> => {
    const { application } = await parse(file);
    if (!application) throw new Error("The application's values couldn't be read.");
    return application;
  },
};
